export const ArticleBody = ({ content, theme }) => (
  <div className="root">
    {content}
    <style jsx>{`
      .root {
        color: var(--bgBlueish__text);
      }

      .root :global(> *) {
        letter-spacing: -0.3px;
        margin-right: ${theme.mobileGutter}px;
        margin-left: ${theme.mobileGutter}px;
        margin-top: 0;
        margin-bottom: ${theme.verticalSpace}rem;
      }

      .root :global(> h2) {
        margin-top: 2em;
        line-height: 1.2;
      }

      .root :global(> p) {
        line-height: 1.6;
      }

      .root :global(> ul) {
        list-style: none;
        padding-left: 1.5rem;
      }

      .root :global(> ul li) {
        position: relative;
        padding-left: 1.25rem;
        margin-bottom: 0.75rem;
        line-height: 1.5;
      }

      .root :global(> ul li::before) {
        position: absolute;
        display: inline-block;
        content: '';
      }

      .root :global(> ul li::before) {
        left: 0;
        top: 9px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: currentColor;
      }

      .root :global(> .aside--larger) {
        margin-left: 9px;
        margin-right: 9px;
      }

      @media screen and (min-width: 750px) {
        .root {
          font-size: 18px;
        }

        .root :global(> *) {
          width: ${theme.contentWidth}%;
          margin-right: 0;
          margin-left: ${theme.leftMargin + theme.gutterWidth}%;
        }

        .root :global(> p) {
          line-height: 1.7;
        }

        .root :global(> aside) {
          float: right;
          width: ${theme.rightMargin}%;
          margin-right: ${theme.gutterWidth}%;
          margin-left: ${theme.gutterWidth}%;
          margin-bottom: ${theme.gutterWidth}%;
        }

        .root :global(> .aside--larger) {
          width: 420px;
          margin-right: ${theme.gutterWidth}%;
          margin-left: ${theme.gutterWidth}%;
        }
      }
    `}</style>
  </div>
);
